import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, SxProps } from '@mui/material';
import { headingFontBold, vars } from '../../../../../Theme';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { onAdvancedExportDocuments } from '../../../../../redux/project/documents/sliceProjectAdvancedExportDialog';
import { fetchViewDataAndDocuments } from '../../../../../util/ProjectUtils';
import { updateSelectedDocuments } from '../../../../../redux/project/documents/sliceProjectSelectedDocuments';
import { useEnqueueSnackbar } from '../../../../../hooks/useEnqueueSnackbar';
import { ToastSeverity } from '../../../Toast/Toast';
import dayjs from 'dayjs';
import { IAdvancedExportErrorState, IAdvancedExportMainState } from '../../_parts/AdvancedExport';

const buttonSx: SxProps = {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    fontFamily: headingFontBold,
    lineHeight: 'normal',
    padding: '9px 12px',
    color: vars.white,
};

export default ({
    setShowErrorState,
    mainState,
    onClose,
    numberOfDocuments,
    isLoading,
}: IAdvancedExportDialogActionsProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'exportDocumentsDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();
    const params = useParams();
    const enqueueSnackbar = useEnqueueSnackbar();

    const { replicaId, areaName } = params;

    const getFileName = () => t('fileName', { dateAndTime: dayjs().format('YYYYMMDDHHmmss') });

    const validateInput = () => {
        const isValid = Boolean(mainState.documentTypeName);
        setShowErrorState({
            documentTypeName: !isValid,
        });
        return isValid;
    };

    const onUpload = () => {
        if (validateInput()) {
            const fileName = getFileName();

            dispatch(
                onAdvancedExportDocuments({
                    ...mainState,
                    replicaId,
                    fileName,
                }),
            );

            dispatch(
                updateSelectedDocuments({
                    replicaId,
                    areaName,
                    documentIds: [],
                }),
            );
            fetchViewDataAndDocuments(params);

            onClose();
            enqueueSnackbar(t('toastInfo', { numberOfDocuments }), {
                severity: ToastSeverity.Info,
            });
        }
    };
    return (
        <DialogActions sx={{ px: 3, py: 1, borderTop: `1px solid ${vars.lightGray}` }}>
            <Button
                variant={'text'}
                onClick={onClose}
                sx={{ ...buttonSx, color: vars.font }}
                disabled={isLoading}
            >
                {t('ctaCancel')}
            </Button>
            <Button
                variant={'contained'}
                onClick={onUpload}
                sx={buttonSx}
                disabled={!numberOfDocuments || isLoading}
            >
                {t('ctaExport')}
            </Button>
        </DialogActions>
    );
};

interface IAdvancedExportDialogActionsProps {
    setShowErrorState: Dispatch<React.SetStateAction<IAdvancedExportErrorState>>;
    mainState: IAdvancedExportMainState;
    onClose: () => void;
    numberOfDocuments: number;
    isLoading?: boolean;
}
